// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nhtml, body {\n  height: calc(var(--vh) * 100);\n  width: 100vw;\n  top: 0;\n  left: 0;\n  position: absolute;\n  margin: 0px;\n  overflow: hidden;\n  -webkit-text-size-adjust: none;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  background-color: black;\n}\n#app {\n  font-family: 'Avenir', Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n", ""]);
// Exports
module.exports = exports;
